<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .question -->
    <b-form-group
      id="input-group-1"
      :label="$t('faqs.question')"
      label-for="input-1"
    >
      <b-form-input
        id="input-1"
        v-model="newItem.question"
        type="text"
        :placeholder="$t('faqs.question')"
      />
    </b-form-group>
    <!-- .answer -->
    <b-form-group
      id="input-group-2"
      :label="$t('faqs.answer')"
      label-for="input-2"
    >
      <b-form-input
        id="input-2"
        v-model="newItem.answer"
        type="text"
        :placeholder="$t('faqs.answer')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Controller from '../../../../Controllers/FaqsController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'FaqsForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
